import { ImageWithMetadata } from '@features/powerpoint';
import {
  SlideMasterProps,
  buildSlideMasterFooter,
  buildSlideMasterHeader,
} from '@features/powerpoint';
import { CampaignWithCalculatedFields } from '@components/Dashboard/hooks/useCampaign';

export const DEFAULT_SLIDE_MASTER = 'MASTER_SLIDE';

export const slideMaster = (
  brandLogoWithMetadata: ImageWithMetadata | null,
  campaign: Pick<CampaignWithCalculatedFields, 'id' | 'name'>
): SlideMasterProps => {
  return {
    title: DEFAULT_SLIDE_MASTER,
    objects: [
      {
        rect: {
          x: 0,
          y: 0,
          w: '100%',
          h: 0.74,
          fill: { color: '262626' },
        },
      },
      ...buildSlideMasterHeader(brandLogoWithMetadata),
      ...buildSlideMasterFooter({
        text: 'Copyright © InMarket All rights reserved.',
        color: '#000000',
      }),
      {
        text: {
          text: `${campaign.name}\n${campaign.id}`,
          options: {
            x: 9.1,
            y: 0.27,
            w: 4.06,
            h: 0.12,
            fontSize: 8,
            color: '#FFFFFF',
            align: 'right',
          },
        },
      },
    ],
  };
};
